import { Switchboards } from "gql/api";

export function computeSwitchboardLabel(
  switchboard?: Partial<Switchboards> | null
): string {
  if (switchboard) {
    return `${switchboard.manufacturer} ${switchboard.part_number}, ${switchboard.amps}, ${switchboard.enclosure}`;
  }
  return "";
}
